import type { EditorAPI } from '#packages/editorAPI';
import _ from 'lodash';
import * as queries from '../queries/openBehaviorsQueries';

export default function getInfoForActions(editorAPI: EditorAPI) {
  const popupPointer = editorAPI.pages.popupPages.getCurrentPopup();
  const allOpenBehaviors =
    editorAPI.pages.popupPages.getOpenBehaviorsForPopups();
  const enabledOpenBehaviors =
    editorAPI.pages.popupPages.getEnabledOpenBehaviorsForPopups();
  const currentOpenBehaviors = allOpenBehaviors.filter(
    (behavior) => behavior.popupId === popupPointer.id,
  );

  const disabledPageIds = queries.getDisabledPageIds(
    enabledOpenBehaviors,
    popupPointer.id,
    editorAPI,
  );

  const allPageIds = editorAPI.dsRead.pages.getPageIdList();

  return {
    allPageIds,
    behaviorDefaults: queries.getSomeBehavior(currentOpenBehaviors, editorAPI)
      .params,
    disabledPageIds: _.zipObject(disabledPageIds),
    enabledPageIds: _.difference(allPageIds, disabledPageIds),
    openBehaviors: currentOpenBehaviors,
    popupPointer,
    selectedPageIds: currentOpenBehaviors.map(({ pageId }) => pageId),
  };
}
